export const promotions = {
  name: 'Promotion |||| Promotions',
  fields: {
    name: 'Name',
    description: 'Description',
    code: 'Code',
    promotionType: 'Promotion Type',
    codeType: 'Code Type',
    discountType: 'Discount Type',
    discountValue: 'Discount Value',
    userType: 'User Type',
    membershipLevels: 'Membership Levels',
    validFrom: 'Valid From',
    validUntil: 'Valid Until',
    timeOfDayStart: 'Time Start',
    timeOfDayEnd: 'Time End',
    daysOfWeek: 'Days of Week',
    minChargeAmount: 'Min Charge Amount',
    maxUsesTotal: 'Max Total Uses',
    maxUsesPerUser: 'Max Uses Per User',
    currentUses: 'Current Uses',
    priority: 'Priority',
    stackableWithCoupons: 'Stackable with Coupons',
    stackableWithPromotions: 'Stackable with Promotions',
    isActive: 'Active',
    sites: 'Sites',
    chargerTypes: 'Charger Types',
    type: 'Type',
    discount: 'Discount',
    status: 'Status',
    uses: 'Uses',
  },
  sections: {
    basicInfo: 'Basic Information',
    typeAndCode: 'Type & Code',
    discount: 'Discount Configuration',
    targeting: 'Target Users',
    validity: 'Validity Period',
    timeConstraints: 'Time Constraints',
    limits: 'Usage Limits',
    advanced: 'Advanced Settings',
    restrictions: 'Restrictions',
  },
  types: {
    coupon: 'Coupon',
    time_limited: 'Time Limited',
  },
  codeTypes: {
    none: 'None',
    shared: 'Shared',
    unique: 'Unique',
  },
  discountTypes: {
    percentage: 'Percentage',
    fixed_amount: 'Fixed Amount',
    free_credit: 'Free Credit',
  },
  userTypes: {
    app: 'App Users',
    rfid: 'RFID Users',
    all: 'All Users',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    scheduled: 'Scheduled',
    expired: 'Expired',
  },
  statusInfo: {
    title: 'Promotion Status',
    redemptions: 'Redemptions: %{current} / %{max}',
  },
  helpers: {
    code: 'Required for shared code type',
    codeType: 'Unique codes are generated separately',
    minChargeAmount: 'Minimum charge amount to qualify',
    membershipLevels: 'Select membership levels (leave empty for all)',
    maxUsesTotal: 'Total redemptions allowed across all users',
    maxUsesPerUser: 'Maximum redemptions per user',
    priority: 'Lower number = higher priority (applies first)',
    sites: 'Leave empty for all sites, or specify inclusions/exclusions',
  },
  memberships: {
    standard: 'Standard',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    vip: 'VIP',
  },
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  priorityLevels: {
    1: '1 - Highest Priority',
    2: '2 - Very High',
    3: '3 - High',
    4: '4',
    5: '5 - Medium',
    6: '6',
    7: '7 - Low',
    8: '8',
    9: '9',
    10: '10 - Lowest Priority',
  },
  multiLanguage: {
    title: 'Multi-language Translations',
    description: 'Provide translations for promotion name and description in different languages. If not provided, the main fields will be used as fallback.',
    copyFromBasic: 'Copy from Basic Info',
    note: 'Note: English is the default language. Other languages are optional and will fall back to the main Name and Description fields if not provided.',
  },
  terms: {
    title: 'Terms & Conditions',
    description: 'Add terms and conditions for this promotion. Terms will be displayed in order in the mobile app.',
    noTerms: 'No terms added yet. Click "Add Term" to add your first term.',
    addTerm: 'Add Term',
    copyFromEnglish: 'Copy from English',
    noteOtherLangs: 'Note: English is the default language. Other languages are optional and will fall back to English if not provided.',
  },
  typeInfo: {
    coupon: 'User must manually enter/apply the code',
    timeLimited: 'Automatically applies during validity period',
  },
  discountFields: {
    percentageLabel: 'Discount Percentage (%)',
    percentageHelper: 'Enter percentage (e.g., 50 for 50% off)',
    fixedAmountLabel: 'Discount Amount (HKD)',
    fixedAmountHelper: 'Enter amount in HKD (e.g., 100 for HKD 100 off)',
    freeCreditLabel: 'Free Credit Amount (HKD)',
    freeCreditHelper: 'Enter credit amount in HKD to add to wallet',
  },
  timeHelpers: {
    leaveEmptyAllDay: 'Leave empty for all day',
    leaveEmptyAllDays: 'Leave empty for all days',
  },
  restrictionHelpers: {
    sitesHelper: 'Leave empty to apply to all sites',
    chargerTypesHelper: 'Leave empty to apply to all charger types',
    selectChargerType: 'Select charger types',
  },
  create: {
    title: 'Create Promotion',
    subtitle: 'Configure a new promotion or coupon campaign',
    backToList: 'Back to promotions list',
    createHint: 'Create promotional campaigns with discount codes, time-limited offers, or special pricing for specific user groups. Set validity periods, usage limits, and targeting rules.',
  },
  show: {
    uniqueCouponCodes: 'Unique Coupon Codes',
    exportCsv: 'Export CSV',
    generateCodes: 'Generate Codes',
    availableCodes: 'Available Codes',
    redeemedCodes: 'Redeemed Codes',
    totalCodes: 'Total Codes',
    searchPlaceholder: 'Search by code, batch name, or partner reference...',
    noCodes: 'No coupon codes generated yet. Click "Generate Codes" to create unique codes for this promotion.',
    termsAndConditions: 'Terms & Conditions',
    timeline: 'Timeline',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    code: 'Code',
    statusLabel: 'Status',
    redeemedAt: 'Redeemed At',
    redeemedBy: 'Redeemed By',
    actions: 'Actions',
    rowsPerPage: 'Rows per page',
    allMembershipLevels: 'All membership levels',
    allDaysOfWeek: 'All days of the week',
    allSites: 'All sites',
    allChargerTypes: 'All charger types',
    available: 'Available',
    redeemed: 'Redeemed',
    noMinimum: 'No minimum',
    generateDialog: {
      title: 'Generate Unique Coupon Codes',
      batchName: 'Batch Name',
      batchNameHelper: 'Name for this batch of codes (e.g., Summer Sale 2025, VIP Batch)',
      numberOfCodes: 'Number of Codes',
      numberOfCodesHelper: 'How many unique codes to generate (max 10,000)',
      codeFormatOptions: 'Code Format Options',
      codeLength: 'Code Length',
      codeLengthHelper: 'Total characters (6-20)',
      segmentLength: 'Segment Length',
      segmentLengthHelper: 'Characters per segment (3-6)',
      separator: 'Separator',
      separatorHelper: 'Character between segments',
      preview: 'Preview:',
      previewText: 'With current settings, codes will look like:',
      expiresOn: 'Codes will expire on:',
      sameAsPromotion: '(same as promotion expiry date)',
      thirtyDays: '30 days from now',
      cancel: 'Cancel',
      generateButton: 'Generate %{quantity} Codes',
    },
  },
  edit: {
    title: 'Edit Promotion',
    typeCodeLocked: 'Promotion type and code type cannot be changed after creation.',
    uniqueCodesManaged: 'Unique coupon codes are managed separately. You can generate and manage codes from the promotion details page.',
    usageInfo: 'This promotion has been used %{count} times.',
    dangerZone: 'Danger Zone',
    cannotDeleteWithRedemptions: 'Cannot delete promotion with redemptions. Deactivate it instead.',
    deleteWarning: 'Permanently delete this promotion. This action cannot be undone.',
    deleteButton: 'Delete',
    deleteButtonTitle: 'Cannot delete promotion with redemptions',
    confirmDeletion: 'Confirm Deletion',
    deletionWarningStrong: 'This action cannot be undone!',
    deletionWarningText: 'You are about to permanently delete %{name}. All promotion data will be lost.',
    typeToConfirm: 'Type %{name} below to confirm:',
    nameDoesNotMatch: 'Name does not match',
    cancel: 'Cancel',
    deletePromotion: 'Delete Promotion',
    selectSites: 'Select sites (leave empty for all sites)',
    selectChargerTypes: 'Select charger types (leave empty for all types)',
  },
  notifications: {
    created: 'Promotion created successfully',
    updated: 'Promotion updated successfully',
    deleted: 'Promotion deleted successfully',
    error: {
      create: 'Failed to create promotion',
      update: 'Failed to update promotion',
      delete: 'Failed to delete promotion',
    },
  },
};